function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { PlayerDrmError, PlayoutDataError } from '../../core/player/playout-data';
import { CvsdkError, ErrorReason, ErrorSeverity } from '../../error';
import { JsonUtils } from '../../utils/json-utils';
import { OvpErrorSource } from './ovp.enums';
export { OvpErrorSource } from './ovp.enums';
var OVP_ERROR_TO_SDK_ERROR = {
    OVP_00019: PlayoutDataError.PARENTAL_PIN_REQUIRED,
    OVP_00020: PlayoutDataError.INVALID_PIN_PROVIDED,
    OVP_00101: PlayoutDataError.PIN_SERVICE_DOWN,
    OVP_00117: PlayerDrmError.ROBUSTNESS_FAILURE
};
var OVP_CONCURRENCY_ERROR_TO_SDK_ERROR = {
    8002: 'OVP_00014'
};
var OvpAdapterError = /*#__PURE__*/ function(CvsdkError) {
    "use strict";
    _inherits(OvpAdapterError, CvsdkError);
    function OvpAdapterError(code, message, severity, cause, category, reason, parameters) {
        _class_call_check(this, OvpAdapterError);
        var _this;
        _this = _call_super(this, OvpAdapterError, [
            code,
            message,
            severity,
            cause,
            category,
            reason !== null && reason !== void 0 ? reason : ErrorReason.Undetermined,
            parameters
        ]);
        Object.setPrototypeOf(_this, OvpAdapterError.prototype);
        // restore prototype chain
        _this.name = "OvpAdapterError: code: ".concat(code);
        return _this;
    }
    _create_class(OvpAdapterError, null, [
        {
            key: "from",
            value: function from(param) {
                var code = param.code, message = param.message, severity = param.severity, cause = param.cause, category = param.category, reason = param.reason, parameters = param.parameters;
                return new OvpAdapterError(code, message, severity, cause, category, reason, parameters);
            }
        }
    ]);
    return OvpAdapterError;
}(CvsdkError);
export var OvpErrorAdapter = /*#__PURE__*/ function() {
    "use strict";
    function OvpErrorAdapter() {
        _class_call_check(this, OvpErrorAdapter);
    }
    _create_class(OvpErrorAdapter, null, [
        {
            key: "adapt",
            value: function adapt(config) {
                switch(config.source){
                    case OvpErrorSource.PLAYER:
                        return this.adaptFromPlayer(config.error);
                    case OvpErrorSource.TOKEN_EXCHANGE:
                        return this.adaptPreauthorized(config.error);
                    case OvpErrorSource.PLAYOUT:
                    default:
                        return this.adaptPlayout(config.error);
                }
            }
        },
        {
            key: "adaptPlayout",
            value: // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Error is always any or unknown when caught
            function adaptPlayout(e) {
                var _e_response, _e_response1;
                return OvpAdapterError.from({
                    code: e.code && OVP_ERROR_TO_SDK_ERROR[e.code] || e.code || ((_e_response = e.response) === null || _e_response === void 0 ? void 0 : _e_response.status) && "OVP_HTTP_".concat(e.response.status) || 'SDK_VPI_FAILURE',
                    message: e.description || ((_e_response1 = e.response) === null || _e_response1 === void 0 ? void 0 : _e_response1.statusText) || e.message || JsonUtils.stringify(e),
                    severity: ErrorSeverity.Fatal,
                    cause: this.adaptCauseMessage(e)
                });
            }
        },
        {
            key: "adaptCauseMessage",
            value: function adaptCauseMessage(error) {
                if (!this.errorIsCommonRequestError(error)) {
                    return error;
                }
                if (error.code === 'OVP_00024') {
                    error.message = "".concat(error.statusCode, " returned from ").concat(error.url);
                }
                return error;
            }
        },
        {
            key: "errorIsCommonRequestError",
            value: function errorIsCommonRequestError(error) {
                return Object.prototype.hasOwnProperty.call(error, 'code') && Object.prototype.hasOwnProperty.call(error, 'statusCode') && Object.prototype.hasOwnProperty.call(error, 'url');
            }
        },
        {
            key: "adaptPreauthorized",
            value: // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Error is always any or unknown when caught
            function adaptPreauthorized(e) {
                var _e_response_body_, _e_response_body, _e_response, _e_response_body_1, _e_response_body1, _e_response1;
                var code = ((_e_response = e.response) === null || _e_response === void 0 ? void 0 : (_e_response_body = _e_response.body) === null || _e_response_body === void 0 ? void 0 : (_e_response_body_ = _e_response_body[0]) === null || _e_response_body_ === void 0 ? void 0 : _e_response_body_.errorCode) || e.code;
                var description = ((_e_response1 = e.response) === null || _e_response1 === void 0 ? void 0 : (_e_response_body1 = _e_response1.body) === null || _e_response_body1 === void 0 ? void 0 : (_e_response_body_1 = _e_response_body1[0]) === null || _e_response_body_1 === void 0 ? void 0 : _e_response_body_1.description) || e.description || e.message;
                return this.adaptPlayout(_object_spread_props(_object_spread({}, e), {
                    description: description,
                    code: OVP_CONCURRENCY_ERROR_TO_SDK_ERROR[code] || code || 'OVP.HEARTBEAT.UNKNOWN'
                }));
            }
        },
        {
            key: "adaptFromPlayer",
            value: // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Error is always any or unknown when caught
            function adaptFromPlayer(e) {
                var reason = e.reason || ErrorReason.Undetermined;
                if (reason !== ErrorReason.DRM) {
                    return e;
                }
                var adaptedCode = "".concat(e.code || 'SDK_PLAYER_FAILURE');
                var ovpErrorMatches = /(OVP_\d{5})/g.exec(JsonUtils.stringify(e));
                var hasMatch = ovpErrorMatches && ovpErrorMatches.length >= 2;
                if (hasMatch && e.code) {
                    var ovpErrorCode = ovpErrorMatches[1];
                    var cvsdkError = OVP_ERROR_TO_SDK_ERROR[ovpErrorCode] || '';
                    adaptedCode = "".concat(cvsdkError ? "".concat(cvsdkError, ".") : '').concat(adaptedCode, "__").concat(ovpErrorCode);
                } else if (e.cause) {
                    var ovpErrorMatches1 = /(OVP_\d{5})/g.exec(e.cause.toString());
                    var hasMatch1 = ovpErrorMatches1 && ovpErrorMatches1.length >= 2;
                    if (hasMatch1 && e.code) {
                        var ovpErrorCode1 = ovpErrorMatches1[1];
                        var cvsdkError1 = OVP_ERROR_TO_SDK_ERROR[ovpErrorCode1] || '';
                        adaptedCode = "".concat(cvsdkError1 ? "".concat(cvsdkError1, ".") : '').concat(adaptedCode, "__").concat(ovpErrorCode1);
                    }
                }
                return OvpAdapterError.from(_object_spread_props(_object_spread({}, e), {
                    code: adaptedCode
                }));
            }
        }
    ]);
    return OvpErrorAdapter;
}();

//# sourceMappingURL=ovp-error-adapter.js.map